CheckItemView = require 'views/checklist/check-item-view'
CollectionView = require 'views/internal/collection-view'

module.exports = class CheckItemListView extends CollectionView
  viewType: CheckItemView



// WEBPACK FOOTER //
// ./app/scripts/views/checklist/check-item-list-view.coffee